import { Cart } from '../components';

const ShoppingCart = () => (
  <main className="main">
    <Cart />
  </main>
);

export default ShoppingCart;
